import { apiClient } from './client';

/**
 * UserExternalProfile API client — backend `apps/chat-server/src/modules/users/user-external-profile.routes.ts`.
 *
 * 사용자별 외부 push (Slack/email/FCM) 매핑 self-service.
 */

export interface ExternalProfileDto {
  slackUserId: string | null;
  externalEmail: string | null;
  fcmDeviceToken: string | null;
  updatedAt: string | null;
}

export type PatchExternalProfileInput = Partial<{
  slackUserId: string | null;
  externalEmail: string | null;
  fcmDeviceToken: string | null;
}>;

export async function getMyExternalProfile(): Promise<ExternalProfileDto> {
  const { data } = await apiClient.get<{ profile: ExternalProfileDto }>('/users/me/external-profile');
  return data.profile;
}

export async function patchMyExternalProfile(body: PatchExternalProfileInput): Promise<ExternalProfileDto> {
  const { data } = await apiClient.patch<{ profile: ExternalProfileDto }>(
    '/users/me/external-profile',
    body,
  );
  return data.profile;
}

// ─── ADMIN — 다른 사용자 매핑 관리 ────────────────────────

export async function getUserExternalProfile(userId: string): Promise<ExternalProfileDto> {
  const { data } = await apiClient.get<{ profile: ExternalProfileDto }>(
    `/users/${userId}/external-profile`,
  );
  return data.profile;
}

export async function patchUserExternalProfile(
  userId: string,
  body: PatchExternalProfileInput,
): Promise<ExternalProfileDto> {
  const { data } = await apiClient.patch<{ profile: ExternalProfileDto }>(
    `/users/${userId}/external-profile`,
    body,
  );
  return data.profile;
}
